import { render, staticRenderFns } from "./googleoauth.vue?vue&type=template&id=00f8b0da&"
import script from "./googleoauth.vue?vue&type=script&lang=js&"
export * from "./googleoauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports